import React from 'react'
import { t } from "i18next";
import { Modal, Spinner } from 'react-bootstrap'
import { useForm } from 'react-hook-form';

function CompanyVerificationModal({ showModal, isLoading, handleLogin, currentUser, handleClose, checkVerificationCode }) {
    const {
        register,
        setError,
        handleSubmit,
        formState: { errors },
    } = useForm();

    return (
        <Modal show={showModal} onHide={handleClose} className="login-modal">
            <Modal.Header closeButton >
                <Modal.Title role="heading" aria-label={t("loginForCompaniesAndOrganizations")}>{t("loginForCompaniesAndOrganizations")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit((data) => checkVerificationCode(data, setError))} className='m-4'>
                    <div className="mb-3 input-field">
                        <div className='mb-4'>
                            <span>{t('smsWasSent')} <span className='phonenum'>{currentUser.phoneNumber}</span></span>
                        </div>
                        <div>
                            <label htmlFor='code'>{t('VerificationCode')}</label>
                            <input
                                {...register("code", {
                                    required: t("VerificationCode"),
                                })}
                                id="code"
                                type='text'
                            />
                            <span className="text-danger">{errors.code?.message}</span>
                        </div>
                    </div>
                    <div className="mb-3 login-btn input-field">
                        <input
                            type="button"
                            className="link"
                            value={t("sendVerifCodeAgain")}
                            onClick={() => handleLogin()}
                        />
                        <button
                            aria-label={t("LoginActn")}
                            className='comp-modal-login-btn'
                            type='submit'
                            disabled={isLoading}
                        >
                            {isLoading && <Spinner className="spinner" animation="border" />}{t("loginBtn")}
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CompanyVerificationModal